import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private readonly LANG_KEY = 'user_lang';

  constructor(private translate: TranslateService) {
    this.init();
  }

  private init(): void {
    this.translate.addLangs(['en', 'vi']);
    this.translate.setDefaultLang('vi');

    const savedLang = localStorage.getItem(this.LANG_KEY);
    const targetLang = (savedLang && this.translate.langs.includes(savedLang)) 
                       ? savedLang 
                       : 'vi'; 

    this.translate.use(targetLang);

    if (!savedLang) {
      localStorage.setItem(this.LANG_KEY, targetLang);
    }
  }

  setLanguage(langCode: string): void {
    if (this.translate.langs.includes(langCode)) {
      this.translate.use(langCode);
      localStorage.setItem(this.LANG_KEY, langCode);
    } else {
      this.translate.use(this.translate.defaultLang);
    }
  }

  // Các hàm khác giữ nguyên...
  getTranslation(key: string | Array<string>, interpolateParams?: Object): Observable<string | any> {
    return this.translate.get(key, interpolateParams);
  }

  getInstantTranslation(key: string | Array<string>, interpolateParams?: Object): string | any {
    return this.translate.instant(key, interpolateParams);
  }

  onLangChange(): Observable<LangChangeEvent> {
    return this.translate.onLangChange;
  }
  
  getCurrentLang(): string {
    return localStorage.getItem(this.LANG_KEY) || this.translate.currentLang || 'vi';
  }
}